import type { Shape } from './en';
import type { plansDe } from './plans.de';

export const plansEn: Shape<typeof plansDe> = {
  title: 'Plans',
  count_one: '{{count}} plan',
  count_other: '{{count}} plans',
  hint: 'PDF or image, up to {{size}} per plan.',
  offline: 'Without a connection for viewing only.',
  offlineChanges: 'No connection: changes go to the server with the next sync.',
  unavailable: 'Without a connection the plans of this record are not available.',
  add: 'Add plan',
  fromPhoto: 'Plan from photo',
  empty: 'No plans yet',
  emptyHint: 'Add floor plans and site plans as PDF or image, or take a photo of a plan.',
  open: 'Open “{{name}}”',
  actions: 'Actions for “{{name}}”',
  moveUp: 'Move “{{name}}” up',
  moveDown: 'Move “{{name}}” down',
  moved: '“{{name}}” is now at position {{position}} of {{count}}.',
  kinds: { pdf: 'PDF', image: 'Image' },
  pdfPages_one: 'PDF with {{count}} page',
  pdfPages_other: 'PDF with {{count}} pages',
  pages_one: '{{count}} page',
  pages_other: '{{count}} pages',
  fileMissing: 'File missing',
  preview: 'Preview of the plan',
  addTitle: 'Add plan',
  editTitle: 'Edit plan',
  added: 'Plan “{{name}}” added',
  queued: 'Plan “{{name}}” saved, its file will be uploaded once there is a connection.',
  saved: 'Plan “{{name}}” saved',
  removed: 'Plan “{{name}}” removed',
  removeTitle: 'Remove plan “{{name}}”?',
  removeDescription: 'The plan and its file are deleted, and so are the positions on this plan.',
  fields: {
    name: 'Name',
    namePlaceholder: 'e.g. Ground floor plan',
    floor: 'Floor',
    floorPlaceholder: 'e.g. GF',
    notes: 'Note',
  },
  photo: {
    title: 'Plan from photo',
    alt: 'Photo of the plan',
    hint: 'Drag the four corners onto the edges of the plan. Everything outside is cut off and the plan is straightened. With the keyboard: choose a corner with Tab, move it with the arrow keys, with Shift in large steps.',
    topLeft: 'Top left corner',
    topRight: 'Top right corner',
    bottomRight: 'Bottom right corner',
    bottomLeft: 'Bottom left corner',
    invalid: 'The corners do not form a quadrilateral. Drag each corner onto a corner of the plan.',
    straighten: 'Straighten',
    skip: 'Use without correction',
  },
  viewer: {
    label: 'Plan “{{name}}”',
    keys: 'Plus and minus zoom, 0 shows the whole plan, the arrow keys move it, Page Up and Page Down turn pages.',
    pickKeys: 'Enter sets the position in the middle.',
    pickHint: 'Tap the spot on the plan',
    marker: 'Position {{labels}}',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    fit: 'Show whole plan',
    loading: 'Loading plan …',
    missing: 'The file of this plan is not uploaded yet.',
    offline: 'Without a connection the file is not available on this device.',
    failed: 'The plan cannot be shown.',
    page: 'Page {{page}} of {{count}}',
    previous: 'Previous page',
    next: 'Next page',
  },
  picker: {
    title: 'Set position',
    editTitle: 'Change position',
    plan: 'Plan',
    chosen: 'Position set on page {{page}}. Tap again to change it.',
    label: 'Name of the position',
    labelHint: 'Helps to tell several positions apart.',
    labelPlaceholder: 'e.g. Door to the north staircase',
    apply: 'Use position',
    draft: 'New',
    none: 'No plans',
    noneHint: 'This record has no plans yet, or they are not on this device.',
  },
  errors: {
    addFailed: '“{{name}}” could not be saved as a plan.',
    unreadable: '“{{name}}” cannot be opened. Please choose an undamaged PDF or image.',
    straightenFailed:
      'The photo could not be straightened. Try again or use it without correction.',
    'too-many-plans': 'A record has at most {{max}} plans.',
    'version-conflict': 'The plan was changed in the meantime. The current version is loaded.',
    orderFailed: 'The order was not saved.',
    removeFailed: '“{{name}}” could not be removed.',
  },
};
